import { createSelector } from 'reselect'

import { userCredentialsSelector } from 'redux/selectors/user'

const interactiveVideoData = state => state.interactiveVideo

export default createSelector(
	[ interactiveVideoData, userCredentialsSelector ],
	(interactiveVideo, userCredentials) => ({
		jwt: userCredentials.interactiveVideo,
		uid: interactiveVideo.uid,
		externalUid: interactiveVideo.externalUid,
	})
)
